import script from "./AssignmentEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignmentEditor.vue?vue&type=script&setup=true&lang=ts"

import "./AssignmentEditor.vue?vue&type=style&index=0&id=2864ba37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2864ba37"]])

export default __exports__